<template>
  <div class="pillars-section">
    <div class="pillars-inner">
      <div class="pillars-header">
        <h2 class="pillars-title reveal">The Hooligans<br />Difference</h2>
        <p class="pillars-subtitle reveal">
          Four commitments we make to every customer, every time.
        </p>
      </div>
      <div class="pillars-grid">
        <div
          v-for="(pillar, idx) in pillars"
          :key="pillar.num"
          class="pillar-card reveal"
          :class="{
            'reveal-delay-1': idx === 1,
            'reveal-delay-2': idx === 2,
            'reveal-delay-3': idx === 3,
          }"
        >
          <span class="pillar-num">{{ pillar.num }}</span>
          <img
            v-if="pillar.iconSrc"
            :src="pillar.iconSrc"
            class="pillar-icon pillar-icon-invert"
            alt=""
          />
          <svg
            v-else-if="pillar.iconSvg"
            class="pillar-icon pillar-icon-svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            aria-hidden="true"
          >
            <rect x="3" y="3" width="18" height="18" rx="0"></rect>
            <path d="M3 9h18M9 3v18"></path>
          </svg>
          <h3 class="pillar-name">{{ pillar.name }}</h3>
          <p class="pillar-desc">{{ pillar.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutPillars",
  props: {
    pillars: {
      type: Array,
      default: () => [
        {
          num: "01",
          iconSrc: "/about/headlines-glasses.svg",
          name: "100% Authentic",
          desc: "Every frame we sell is a genuine article — sourced directly from the brand or authorized distributors. Your trust is our most important asset.",
        },
        {
          num: "02",
          iconSvg: true,
          name: "In-House Inventory",
          desc: "We own every item we list. No waiting on suppliers, no out-of-stock surprises. If it's on our site, it's in our warehouse — ready to ship today.",
        },
        {
          num: "03",
          iconSrc: "/about/headlines-benefits.svg",
          name: "Affordable Luxury",
          desc: "Designer eyewear without the designer markup. We cut out the middlemen so you get the frames you love at prices that make sense.",
        },
        {
          num: "04",
          iconSrc: "/about/headlines-delivery.svg",
          name: "Free U.S. Standard Shipping",
          desc: "U.S. standard shipping is free. International shipping is $20. Express U.S. shipping is available for $15.",
        },
      ],
    },
  },
};
</script>
